<template lang="pug">
    md-menu(md-close-on-select)
        md-button.md-flat.md-dense(md-text-scrim md-menu-trigger :style="titleColor") {{ languageLabel }}
        md-menu-content
          md-menu-item(v-for="(lang,index) in languages" :key="index" @click="changeLanguage(lang.key)"  :class="{ 'is-selected': isCurrentLanguage(lang) }" style="color: rgb(1, 44, 88);") {{lang.label}}
</template>
<script>
import { mapGetters, mapState } from 'vuex'
import { Trans } from '@/i18n/Translation'
import { SET_LANGUAGE } from '@/constants/store'
export default {
  name: 'LanguageMenu',
  props: ['titleColor'],
  computed: {
    ...mapState([
      'languages',
      'language'
    ]),
    ...mapGetters([
      'languageLabel'
    ])
  },
  methods: {
    changeLanguage (e) {
      const lang = e // .target.value
      const to = this.$router.resolve({ params: { lang } })
      return Trans.changeLanguage(lang).then(() => {
        this.$store.commit(SET_LANGUAGE, lang)
        this.$store.dispatch('setLanguage')
        this.$router.replace(to.location)
      })
    },
    isCurrentLanguage (lang) {
      return lang === this.currentLanguage
    },
    setLang (key) {
      this.$i18n.locale = key
      this.$store.commit(SET_LANGUAGE, key)
      this.$store.dispatch('setLanguage')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/LanguageMenu.vue